export default __webpack_public_path__ + "static/media/6.3d5a41b4.png";